/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */
var $ = require("jquery");
var Flickity = require('flickity');

if($('.block-page-header-visual .slider').length > 0) {
    const flkty = new Flickity('.block-page-header-visual .slider', {
        cellAlign: 'left',
        autoPlay: 5000,
        pageDots: true,
        prevNextButtons: false,
    });
}
